// extracted by mini-css-extract-plugin
module.exports = {"container":"TrabajandoStyles_container__EgGFS","conInfo__p":"TrabajandoStyles_conInfo__p__1NNMU"};